export const Lotus = ({ className = "w-8 h-8", color = "#E8A0A8" }) => (
  <svg viewBox="0 0 48 32" className={className} aria-hidden="true">
    <path d="M24 30C19 24 19.5 14 24 6C28.5 14 29 24 24 30Z" fill={color} />
    <path d="M24 30C16 29 9 23 6 14C14 15 21 21 24 30Z" fill={color} opacity=".7" />
    <path d="M24 30C32 29 39 23 42 14C34 15 27 21 24 30Z" fill={color} opacity=".7" />
    <path d="M24 30C14 31 5 28 1 22C9 21 18 24 24 30Z" fill={color} opacity=".4" />
    <path d="M24 30C34 31 43 28 47 22C39 21 30 24 24 30Z" fill={color} opacity=".4" />
  </svg>
);

export const Feather = ({ className = "w-6 h-16" }) => (
  <svg viewBox="0 0 24 64" className={className} aria-hidden="true">
    <path d="M12 2C21 12 22 26 12 36C2 26 3 12 12 2Z" fill="#F7E8E3" stroke="#D5AD66" strokeWidth="1.2" />
    <ellipse cx="12" cy="20" rx="5" ry="6.5" fill="#8E9D78" />
    <ellipse cx="12" cy="21" rx="2.8" ry="3.8" fill="#C96B52" />
    <circle cx="12" cy="21.8" r="1.4" fill="#403434" />
    <path d="M12 36V62" stroke="#D5AD66" strokeWidth="1.2" />
  </svg>
);

export const Divider = () => (
  <div className="flex items-center justify-center gap-4 my-2" aria-hidden="true">
    <span className="h-px w-16 bg-gold/60" />
    <Lotus className="w-8 h-6" />
    <span className="h-px w-16 bg-gold/60" />
  </div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.28em] text-terra-deep flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-terra" />
    {children}
  </p>
);
